module.exports = __webpack_public_path__ + "img/school.ae0e675b.svg";